import styled from 'styled-components'
import Section, { Panel, SectionPanels } from './Section'
import { mediaTabletAndMobile } from '../styles/breakPoints'
import i18n, { t, tStr } from '@utils/lang'

const PaddedPanel = styled(Panel)`
  padding: 0;
  > div {
    padding: 0 7%; // using % so text continues to match up with images when resized
  }
`

const Disclaimer = styled.div`
  padding: 24px 2%;
  color: var(--themeColorForegroundSecondary);
  font-size: ${p => p.theme.font.size.caption};
  font-weight: ${p => p.theme.font.weight.light};
  line-height: ${p => p.theme.font.lineHeight};
  ${mediaTabletAndMobile} {
    width: 100%;
    max-width: 500px;
    padding: 24px 6%;
    margin: auto;
  }
`

const Desc = styled.div`
  color: var(--themeColorForegroundSecondary);
  font-size: ${p => p.theme.font.size.title};
  font-weight: ${p => p.theme.font.weight.normal};
  line-height: ${p => p.theme.font.lineHeight};
  margin: -16px auto 64px;
  text-align: center;
  max-width: 700px;
`

const PayBreakdown = () => (
  <Section title={tStr('payTitle_s')} tagLine={tStr('payTagLine_s')}>
    <Desc>{t('payDesc_s')}</Desc>
    <SectionPanels>
      <PaddedPanel
        title={tStr('payBaseTitle_s')}
        img={<img src={`/images/${i18n.locale}/payBreakdownBase.png`} alt="" />}
      >
        {t('payBaseBody_s')}
      </PaddedPanel>
      <PaddedPanel
        title={tStr('payTipsTitle_s')}
        img={<img src={`/images/${i18n.locale}/payBreakdownTip.png`} alt="" />}
      >
        {t('payTipsBody_s')}
      </PaddedPanel>
      <PaddedPanel
        title={tStr('payPromosTitle_s')}
        img={<img src={`/images/${i18n.locale}/payBreakdownIncentives.png`} alt="" />}
      >
        {t('payPromosBody_s')}
      </PaddedPanel>
    </SectionPanels>
    <Disclaimer>{t('payDisclaimer_s')}</Disclaimer>
  </Section>
)

export default PayBreakdown
